import { RootState } from '..';

export const errorSelector = (state: RootState) => state.error;
